module.exports = __webpack_public_path__ + "img/3.1fab71b0.jpg";